import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import MembershipSelectTable from './MembershipSelectTable';

// This component is rendered on the new incident alert Rails form to allow
// for the alerting of individual Memberships instead of Tasks
// /groups/44/incidents/new?incidents_incident_alert=true&locale=nl
const MembershipSelectTableContainer = props => (
  <Provider store={store}>
    <MembershipSelectTable {...props} />
  </Provider>
);

export default MembershipSelectTableContainer;
